import { BaseEpisodeCardElementMixin } from "%/dynamic-component-editor/standard-components/base-episode-card/base-episode-card-element-mixin";

export const EpisodeCardSmallElementMixin = {
  extends: BaseEpisodeCardElementMixin,
};
